import { Injectable } from '@angular/core';
import { AuthConfig, LoginOptions, OAuthEvent, OAuthSuccessEvent, TokenResponse } from 'angular-oauth2-oidc';
import { Observable } from 'rxjs';
import { IOAuthService } from './ioauth-service';

/**
 * Inert OAuthService used in plugin/iframe contexts (coyo/staffbase/
 * iframe/unily): no tokens, no redirects, no discovery.
 */
@Injectable()
export class MockOAuthService extends AuthConfig implements IOAuthService {
  constructor() {
    super();
  }

  events: Observable<OAuthEvent> = new Observable<OAuthEvent>();
  state?: string = undefined;

  configure(config: AuthConfig): void {}

  loadDiscoveryDocument(fullUrl?: string): Promise<OAuthSuccessEvent | undefined> {
    return Promise.resolve(undefined);
  }

  tryLogin(options?: LoginOptions): Promise<boolean> {
    return Promise.resolve(false);
  }

  initCodeFlow(additionalState?: string, params?: object): void {}

  refreshToken(): Promise<TokenResponse | undefined> {
    return Promise.resolve(undefined);
  }

  logOut(): void;
  logOut(noRedirectToLogoutUrl: boolean): void;
  logOut(noRedirectToLogoutUrl?: boolean): void {}

  getIdentityClaims(): Record<string, any> | undefined {
    return undefined;
  }

  getIdToken(): string {
    return '';
  }

  getAccessToken(): string {
    return '';
  }

  getRefreshToken(): string {
    return '';
  }

  getAccessTokenExpiration(): number {
    return 0;
  }

  getIdTokenExpiration(): number {
    return 0;
  }

  hasValidAccessToken(): boolean {
    return false;
  }

  hasValidIdToken(): boolean {
    return false;
  }
}
